(function () {
    try {
      /* main variables */
      var debug = 0;
      var variation_name = "";
      var $;
      /* all Pure helper functions */
      function waitForElement(selector, trigger, delayInterval, delayTimeout) {
        var interval = setInterval(function () {
          if (
            document &&
            document.querySelector(selector) &&
            document.querySelectorAll(selector).length > 0
          ) {
            clearInterval(interval);
            trigger();
          }
        }, delayInterval);
        setTimeout(function () {
          clearInterval(interval);
        }, delayTimeout);
      }
      function init() {
        document.body.classList.add('EG-COOKIE-BANNER');
        document.querySelector('.pd-cookie-banner-window .cc-logo img').src = 'https://www.trooper.ch/cdn/shop/files/logo-1696836935.webp?v=1697546596&width=450';
        const logo = document.querySelector('.pd-cookie-banner-window .cc-logo');
        if(logo){
          logo.insertAdjacentHTML('afterend','<h3 class="eg-cookie-heading">Cookie-Einstellungen</h3>');
        }
        document.querySelector('.pd-cookie-banner-window .cc-compliance .cc-allow').textContent = 'Akzeptieren & Schließen';
      }
      /* Initialize variation */
      waitForElement('.pd-cookie-banner-window .cc-logo img', init, 50, 15000);
    } catch (e) {
      if (debug) console.log(e, "error in Test" + variation_name);
    }
  })();